import type { Variant } from '@velasca/types'

/**
 * It returns the SKU of the current product, or the sku of first variant if the current product is not found.
 *
 * @param currentProductId - The ID of the current product.
 * @param variants - The variants of the current product.
 * @returns The sku of the current product.
 */
export const getSkuFromCurrentProduct = (
  currentProductId: string | null | undefined,
  variants: Variant[],
): string | undefined => {
  let currentProduct

  if (currentProductId) {
    currentProduct = variants.find(
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-conversion
      (e) => e.id.toString() === currentProductId.toString(),
    )
  }

  return currentProduct ? currentProduct.sku : variants[0]?.sku
}
